import en from './default.en.json';
import pt from './default.json';

type ILocale = {
  'pt-BR': {
    menu?: unknown;
    [key: string]: unknown;
  };
  'en-US': {
    menu?: unknown;
    [key: string]: unknown;
  };
};

const ptLocale: Partial<ILocale> = pt as Partial<ILocale>;
const enLocale: Partial<ILocale> = en as Partial<ILocale>;

if (!ptLocale['pt-BR']) ptLocale['pt-BR'] = {};
if (!enLocale['en-US']) enLocale['en-US'] = {};

export { enLocale as en, ptLocale as pt };
